import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalEquipmentSectionDto } from "../dto/solar-proposal-equipment.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Proposal equipment section read. Like the design read, it loads
 * and fails apart from the header read, so its errors stay inside the section.
 */
export default function useSolarProposalEquipment(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalEquipmentSectionDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.equipment(proposalId ?? ``),
    queryFn: () => solarProposalService.getEquipment(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
